import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/payment-plans']['PUT'];

type Input = ThisApi['query'] & ThisApi['body'];
type Output = ThisApi['response'];

const searchPaymentPlans = async ({ page, perPage, ...body }: Input): Promise<Output> => {
  const response = await noodleApiClient.put('/payment-plans', body, {
    params: { page, perPage },
  });
  return response.data;
};

export default searchPaymentPlans;
